
import { PageableDto } from "./pageable.dto";
import { PlainAccomodationDto } from "./plain-accomodation.dto";
import { SortDto } from "./sort.dto";

export class  ResponsePaginationTableDto{

    constructor(
       public content?: PlainAccomodationDto[],
       public pageable?: PageableDto,
       public last?: boolean,
       public totalElements?: number,
       public totalPages?: number,
       public size?: number,
       public number?: number,
       public sort?: SortDto,
       public first?:boolean,
       public numberOfElements?: number,
       public empty?: boolean
    ) {}
}